import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue";
var _hoisted_1 = { class: "country-select position-relative w-100" };
var _hoisted_2 = { class: "placeholder-text" };
var _hoisted_3 = ["src"];
var _hoisted_4 = {
    class: "position-absolute z-3 mt-1 border rounded bg-white w-full shadow-md",
    style: { "bottom": "calc(100% - 10px)", "max-height": "50vh", "overflow-y": "scroll" }
};
var _hoisted_5 = ["onClick"];
var _hoisted_6 = ["src"];
import { ref, computed, onMounted } from 'vue';
import { toast } from 'vue3-toastify';
import { notify } from '@/utils/toast';
import { getCountries } from '@/api/public/client';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CountrySelect',
    props: {
        modelValue: {}
    },
    emits: ["update:modelValue"],
    setup: function (__props, _a) {
        var _this = this;
        var __expose = _a.expose, __emit = _a.emit;
        var props = __props;
        var emit = __emit;
        var open = ref(false);
        var countries = ref([]);
        var selected = computed(function () { return countries.value.find(function (c) { return c.id === props.modelValue; }); });
        __expose({
            setCountry: setCountry
        });
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            var countriesResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getCountries()];
                    case 1:
                        countriesResponse = _a.sent();
                        if (countriesResponse.status === 200) {
                            countries.value = countriesResponse.data;
                        }
                        else {
                            notify('Error al cargar los países', 'danger', toast.POSITION.BOTTOM_CENTER);
                        }
                        return [2 /*return*/];
                }
            });
        }); });
        function selectCountry(country) {
            emit('update:modelValue', country.id);
            open.value = false;
        }
        function setCountry(countryId) {
            var country = countries.value.find(function (c) { return c.id === countryId; });
            if (country) {
                emit('update:modelValue', country.id);
            }
            else {
                notify('País no encontrado', 'warning', toast.POSITION.BOTTOM_CENTER);
            }
        }
        return function (_ctx, _cache) {
            var _a, _b;
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("button", {
                    class: "wrapper border rounded btn btn-white px-3 py-2 w-100 text-left d-flex justify-content-between align-items-center",
                    onClick: _cache[0] || (_cache[0] = function ($event) { return (open.value = !open.value); })
                }, [
                    _createElementVNode("span", _hoisted_2, [
                        (selected.value !== undefined && selected.value.code !== undefined)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                class: "img-fluid",
                                style: { "width": "24px" },
                                src: 'https://flagcdn.com/w40/' + ((_a = selected.value) === null || _a === void 0 ? void 0 : _a.code) + '.png'
                            }, null, 8, _hoisted_3))
                            : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(((_b = selected.value) === null || _b === void 0 ? void 0 : _b.name) || 'Selecciona tu país de residencia'), 1)
                    ]),
                    _cache[1] || (_cache[1] = _createElementVNode("span", null, "▾", -1))
                ]),
                _withDirectives(_createElementVNode("ul", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(countries.value, function (country) {
                        return (_openBlock(), _createElementBlock("li", {
                            key: country.id,
                            class: "px-3 py-2 hover:bg-gray-100 cursor-pointer flex items-center",
                            onClick: function ($event) { return (selectCountry(country)); }
                        }, [
                            _createElementVNode("img", {
                                class: "img-fluid",
                                style: { "width": "24px" },
                                src: 'https://flagcdn.com/w40/' + country.code + '.png'
                            }, null, 8, _hoisted_6),
                            _createTextVNode(" " + _toDisplayString(country.name), 1)
                        ], 8, _hoisted_5));
                    }), 128))
                ], 512), [
                    [_vShow, open.value]
                ])
            ]));
        };
    }
});
